import { Autocomplete, debounce, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { IGuestAndSpeakers } from 'src/Types/module/guestAndSpeaker/type/guestAndSpeaker';
import GetDataApi from './FetchData/GetDataApi';

const CommonMultipleSelectSpeakers = ({
  onChange,
  defaultData,
  label,
  size,
  onAddValue,
  onRemoveValue,
}: {
  size?: 'small' | 'medium';
  label?: string;
  onChange: (number: number[]) => void;
  defaultData?: {
    guest_speaker_id: number;
    guest_speaker_name: string;
  }[];
  onRemoveValue?: (number: number[]) => void;
  onAddValue?: (number: number[]) => void;
}) => {
  const [allMember, setAllMember] = useState<IGuestAndSpeakers[] | any>([]);
  const [companyName, seTCompanyName] = useState<string>('');
  const { getData, loading, success, response } = GetDataApi<
    IGuestAndSpeakers[]
  >('/api/fair/get/speaker/all/all', true);
  useEffect(() => {
    getData();
  }, []);

  const handelInputChange = debounce((value: string) => {
    seTCompanyName(value);
  }, 500);
  return (
    <Autocomplete
      defaultValue={defaultData || []}
      size={size || 'small'}
      multiple
      isOptionEqualToValue={(option, value) =>
        option.guest_speaker_name === value.guest_speaker_name
      }
      onInputChange={(_event, newInputValue) => {
        handelInputChange(newInputValue);
      }}
      getOptionLabel={(option: IGuestAndSpeakers) => option.guest_speaker_name}
      options={response || []}
      onChange={(_event, newValue: IGuestAndSpeakers[]) => {
        if (newValue && newValue?.length) {
          const memberIds = newValue?.map((member) => member.guest_speaker_id);
          onChange && onChange(memberIds);

          // if addNewValue or removeExisValue---------when updating----------
          if (defaultData && defaultData?.length) {
            const defaultValueIds = defaultData?.map(
              (member) => member.guest_speaker_id
            );
            const removeValue = defaultValueIds?.filter(
              (value) => !memberIds.includes(value)
            );
            const addedValue = memberIds.filter(
              (value) => !defaultValueIds.includes(value)
            );
            onAddValue && onAddValue(addedValue);
            onRemoveValue && onRemoveValue(removeValue);
          }
        }
      }}
      renderInput={(params) => (
        <TextField {...params} label={label || 'Select speaker'} />
      )}
    />
  );
};

export default CommonMultipleSelectSpeakers;
